// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main>.holder .title[data-v-289cf095]{margin-bottom:50px}", ""]);
// Exports
module.exports = exports;
